import React, { useCallback, useState } from 'react';
import Modal from 'utils/packages/Modal';
import useFetch from 'hooks/useFetch';
import { useAppDispatch } from 'store/hooks';
import { ThrowableFetchError } from 'hooks';
import OrderSendingView from '../components/OrderSendingView';
import { cancelOrder, getOrders } from '../actions';
import { SellOrderType } from '../types';
const strings = {
    cancelFailed: 'Failed to cancel',
};
const fetchConfig = {
    debug: false,
    throws: true,
    muteError: false,
    muteResult: false,
    muteFetching: false,
};
const useOrderCancel = () => {
    const [loading, setLoading] = useState(false);
    const [, , , fetch] = useFetch(fetchConfig);
    const dispatch = useAppDispatch();
    const cancelCallback = useCallback(async (orderId, onSuccess, pin, assetId, orderType, tradingAccountId) => {
        const content = <OrderSendingView cancel/>;
        Modal.show(content, {
            top: true,
            fullscreen: true,
            nonDismissable: true,
            minShowTime: 1500,
        });
        setLoading(true);
        try {
            const result = await fetch(cancelOrder(orderId, pin, tradingAccountId));
            if (!result) {
                throw new Error();
            }
            else {
                if (orderType === SellOrderType.MARKET) {
                    // Refreshing market orders for the main list as well as for symbol
                    dispatch(getOrders({
                        accountId: tradingAccountId,
                        statuses: ['queued', 'pending'],
                        orderTypes: [SellOrderType.MARKET],
                    }));
                    if (assetId) {
                        dispatch(getOrders({
                            assetIds: [assetId],
                            accountId: tradingAccountId,
                            statuses: ['queued', 'pending'],
                            orderTypes: [SellOrderType.MARKET],
                        }));
                    }
                }
                else {
                    // Refreshing limit and stop orders for the main list as well as for symbol
                    dispatch(getOrders({
                        accountId: tradingAccountId,
                        statuses: ['pending', 'queued'],
                        orderTypes: [SellOrderType.LIMIT, SellOrderType.STOP],
                    }));
                    if (assetId) {
                        dispatch(getOrders({
                            assetIds: [assetId],
                            accountId: tradingAccountId,
                            statuses: ['pending', 'queued'],
                            orderTypes: [SellOrderType.LIMIT, SellOrderType.STOP],
                        }));
                    }
                }
                onSuccess();
                Modal.hide(undefined, { top: true });
            }
            setLoading(false);
            return result;
        }
        catch (error) {
            // failed to execute an order
            setLoading(false);
            const fetchError = error instanceof ThrowableFetchError ? error : undefined;
            if (fetchError?.fetchError.errorType === 'PinError') {
                Modal.hide(undefined, { top: true });
                throw error;
            }
            else {
                Modal.hide(() => {
                    Modal.showError(strings.cancelFailed, () => {
                        cancelCallback(orderId, onSuccess, pin, assetId, orderType, tradingAccountId);
                    });
                }, { top: true });
            }
            return undefined;
        }
    }, [dispatch, fetch]);
    return [cancelCallback, loading];
};
export default useOrderCancel;
